export const CHANGE_PROPERTY_RECORD_FIELD_VALUE =
  'CHANGE_PROPERTY_RECORD_FIELD_VALUE';
export const CHANGE_UNIT_RECORD_FIELD_VALUE = 'CHANGE_UNIT_RECORD_FIELD_VALUE';
export const REMOVE_RENEWAL_RECORDS = 'REMOVE_RENEWAL_RECORDS';
export const RESET_RENEWAL_RECORD = 'RESET_RENEWAL_RECORD';
export const RESET_RENEWAL_RECORDS = 'RESET_RENEWAL_RECORDS';
export const SET_RENEWAL_RECORDS = 'SET_RENEWAL_RECORDS';
